(function () {
  'use strict';

  // ================= SETTINGS =================
  var DBG = false;
  var LANG_MAP = { en: '/', ru: '/ru', th: '/th' };
  var DEFAULT_LANG = 'en';
  var COOKIE_NAME = 'preferred_lang_v3';
  var COOKIE_DAYS = 365;

  function log() {
    if (DBG && window.console && console.log) {
      console.log.apply(console, ['[locale]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  // ================= COOKIES =================
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = name + '=' + encodeURIComponent(value) + '; Path=/; Expires=' + d.toUTCString() + '; SameSite=Lax' + secure;
    log('cookie set', name, value);
  }

  // ================= HELPERS =================
  function getCurrentLanguageFromPath() {
    var path = location.pathname.toLowerCase();
    if (path === '/ru' || path.indexOf('/ru/') === 0) return 'ru';
    if (path === '/th' || path.indexOf('/th/') === 0) return 'th';
    return 'en';
  }

  function buildLocalizedUrl(langCode) {
    var currentPath = location.pathname.replace(/^\/(ru|th)(\/|$)/i, '/');
    var prefix = LANG_MAP[langCode];
    var tail = location.search + location.hash;
    if (prefix === '/') return currentPath + tail;
    if (currentPath === '/') return prefix + tail;
    return prefix + currentPath + tail;
  }

  // ================= LANGUAGE DETECTION =================
  function detectLanguage() {
    // 1. User choice (cookie)
    var saved = getCookie(COOKIE_NAME);
    if (saved && LANG_MAP[saved]) {
      log('language from cookie', saved);
      return saved;
    }
    // 2. Device language
    var nav = (navigator.languages && navigator.languages.length) ? navigator.languages : [navigator.language || ''];
    var base = String(nav[0] || '').toLowerCase().split('-')[0];
    log('device language', base);
    if (base === 'ru') return 'ru';
    if (base === 'th') return 'th';
    // 3. Country fallback
    var country = (window.Shopify && Shopify.country) ? String(Shopify.country).toUpperCase() : '';
    log('country', country);
    if (country === 'TH') return 'th';
    if (country === 'RU' || country === 'BY' || country === 'UA') return 'ru';
    // 4. Default
    return DEFAULT_LANG;
  }

  function applyLanguage(langCode) {
    if (!LANG_MAP[langCode]) langCode = DEFAULT_LANG;
    setCookie(COOKIE_NAME, langCode, COOKIE_DAYS);
    if (getCurrentLanguageFromPath() === langCode) {
      log('already correct language');
      return;
    }
    var targetUrl = buildLocalizedUrl(langCode);
    log('redirect to', targetUrl);
    location.replace(targetUrl);
  }

  // ================= INIT =================
  try {
    var isPreview = location.search.indexOf('preview_theme_id') !== -1;

    // ВАЖНО (исправлено 21.09.2026): в РЕДАКТОРЕ ТЕМЫ редиректа быть не должно.
    // Редактор открывает витрину внутри себя и работает только на основном языке
    // магазина (английском). Без этих двух проверок скрипт перебрасывал редактор
    // на /ru, и вместо редактирования появлялся экран
    // «Themes can only be edited in the store's primary language (English)» —
    // войти в редактирование было невозможно.
    var isDesignMode = !!(window.Shopify && window.Shopify.designMode);
    var isFramed;
    try {
      isFramed = window.top !== window.self;
    } catch (e) {
      isFramed = true; // чужой домен сверху — значит точно в рамке
    }

    var isAdmin = location.pathname.indexOf('/admin') === 0;
    var isApps = location.pathname.indexOf('/apps') === 0;
    var isBot = /bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent || '');

    if (!isPreview && !isDesignMode && !isFramed && !isAdmin && !isApps && !isBot) {
      applyLanguage(detectLanguage());
    }
  } catch (err) {
    console.error('Language redirect error:', err);
  }

  // ================= MANUAL SWITCH =================
  // Remember the language the visitor picks in the EN | RU | TH switcher
  // (Shopify localization form), so the auto-redirect never overrides it.
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest
      ? e.target.closest('button[name="locale_code"], a[hreflang][data-value], [data-locale-code]')
      : null;
    if (!el) return;
    var code = String(el.value || el.getAttribute('data-value') || el.getAttribute('data-locale-code') || '').toLowerCase().split('-')[0];
    if (LANG_MAP[code]) setCookie(COOKIE_NAME, code, COOKIE_DAYS);
  }, true);

  window.setPreferredLanguage = function (langCode) {
    langCode = String(langCode || '').toLowerCase();
    if (!LANG_MAP[langCode]) {
      console.warn('Unknown language:', langCode);
      return;
    }
    setCookie(COOKIE_NAME, langCode, COOKIE_DAYS);
    location.href = buildLocalizedUrl(langCode);
  };
})();